import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchXtdByPubProps = {
  clusters?: Array<string>;
  partners?: Array<number>;
  origami?: string;
  am?: Array<string>;
};
export type FetchXtdByPub = (filters: FetchXtdByPubProps) => void;

const fetchXtdByPub = ({
  clusters = [],
  partners = [],
  origami,
  am = [],
}: FetchXtdByPubProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    cluster: clusters.length ? "'" + clusters.join("','") + "'" : null,
    partner: partners.join(","),
    enable_origami: origami,
    account_manager: am.length ? "'" + am.join("','") + "'" : null,
  };
  await fetchReport("xtd_by_pub", dispatch, params);
};

export default fetchXtdByPub;
